type SupportedTypes = 'string' | 'number' | 'boolean'

/** takes and object and flattens so that each nested key becomes a top level dot access key, used for parameter store etc */

export const convertToDotKey = (input: Record<string, any>, target: Record<string, SupportedTypes> = {}, currentKeyPath: string[] = []) => {
  const entries = Object.entries(input)

  for (let [k, v] of entries) {
    const thisKeyPath = [...currentKeyPath, k]
    if (['string', 'number', 'boolean'].includes(typeof v)) {
      const thisKey = thisKeyPath.join('.')
      target[thisKey] = v
    } else if (!!v && typeof v === 'object') {
      convertToDotKey(v, target, thisKeyPath)
    }
  }

  return target
}
